module.exports = __webpack_public_path__ + "static/media/ER.85dfa3fb.png";